module.exports = __webpack_public_path__ + "static/img/bunny-character.13b33f0.png";